module.exports = __webpack_public_path__ + "static/media/cityNightLights.caee99e0.png";